// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const HierarchySquareIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "HierarchySquare/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.492 1.667H6.508c-3.033 0-4.841 1.808-4.841 4.841v6.975c0 3.042 1.808 4.85 4.841 4.85h6.975c3.034 0 4.842-1.808 4.842-4.841V6.508c.008-3.033-1.8-4.841-4.833-4.841ZM8.208 13.708A1.71 1.71 0 0 1 6.5 15.417a1.71 1.71 0 0 1-1.708-1.709 1.7 1.7 0 0 1 1.083-1.583V8.55a1.835 1.835 0 0 1-1.208-1.717C4.667 5.825 5.492 5 6.5 5s1.833.825 1.833 1.833c0 .792-.508 1.459-1.208 1.717v3.575c.633.25 1.083.867 1.083 1.583Zm5.75 1.709a1.71 1.71 0 0 1-1.708-1.709 1.7 1.7 0 0 1 1.083-1.583V7.292a.206.206 0 0 0-.208-.209h-.942l.175.142c.267.225.3.617.084.883a.632.632 0 0 1-.884.084l-1.5-1.25a.648.648 0 0 1-.225-.484c0-.183.084-.358.225-.483l1.5-1.25a.632.632 0 0 1 .884.083.624.624 0 0 1-.084.884l-.175.141h.942c.8 0 1.458.659 1.458 1.459v4.833c.634.25 1.084.867 1.084 1.583a1.71 1.71 0 0 1-1.709 1.709Z"
}));
export default HierarchySquareIcon;